import { MENU_TYPE_OBJ } from '../constants';

export const LNB_LIST = [
  {
    id: MENU_TYPE_OBJ.DALIY_VIEW_RANK,
    text: '일간 조회수 TOP',
  },
  {
    id: MENU_TYPE_OBJ.SALARY_RANK,
    text: '전체 평균연봉 TOP',
  },
  {
    id: MENU_TYPE_OBJ.PUBLIC_SALARY_RANK,
    text: '공기업 평균연봉 TOP',
  },
  {
    id: MENU_TYPE_OBJ.RECENT_SALARY_RANK,
    text: '입사자 평균연봉 TOP',
  },
];
